import { Link } from "react-router-dom";
import { SignOut } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

export default function NoEvent() {
  const { user, logout } = useAuth();
  return (
    <div className="grain-bg min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md text-center animate-fade-up" data-testid="no-event-state">
        <p className="eyebrow text-accent">Gledswood Homestead + Winery</p>
        <h1 className="font-heading text-4xl font-light tracking-tight text-primary mt-2">You're not connected to an event yet</h1>
        <p className="text-muted-foreground mt-4">
          Your account is ready, {user?.name}. Once Gledswood adds you to your event, your planning
          portal will appear here automatically. Please contact Gledswood if you're expecting access.
        </p>
        <p className="text-sm text-muted-foreground mt-6">events@gledswood.com.au</p>
        <div className="mt-8 flex items-center justify-center gap-4">
          <Link to="/privacy" className="text-sm text-muted-foreground underline hover:text-primary">Privacy Policy</Link>
          <button onClick={logout} data-testid="no-event-logout" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary">
            <SignOut size={16} /> Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
